<template>
  <v-navigation-drawer
    v-model="showFiltersComp"
    :permanent="$vuetify.breakpoint.mdAndUp"
    app
    hide-overlay
    bottom
    clipped
    class="px-8 py-8 mb-8 grey lighten-5"
    width="320"
  >
    <MainFilters v-if="false === hideForCollection" />
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from "vuex";
import store from "@/store/";
import { TOGGLE_SHOW_FILTERS } from "@/store/actions.type";

export default {
  name: "LeftNav",
  data: () => ({
    drawer: true,
    showFilterComp: true,
  }),
  computed: {
    hideForCollection() {
      // if (String(this.$route.name).toLowerCase().includes('collection')) {
      if ('singleCollection' === this.$route.name) {
        return true;
      }
      return false;
    },
    ...mapGetters(["showFilters"]),
    showFiltersComp: {
      get() {
        return this.showFilters;
      },
      set(val) {
        // This will catch a user click when not using the toggle button
        if (val === false) store.dispatch(TOGGLE_SHOW_FILTERS);
      },
    },
  },
};
</script>
